import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import Card, {
	CardActions,
	CardBody,
	CardFooter,
	CardFooterRight,
	CardHeader,
	CardLabel,
	CardSubTitle,
	CardTabItem,
	CardTitle,
} from '../../../components/bootstrap/Card';
import Checks from '../../../components/bootstrap/forms/Checks';
import { Modal } from 'react-bootstrap'; // Changed import
import Icon from '../../../components/icon/Icon';
import SignatureCanvas from 'react-signature-canvas';
import Spinner from '../../../components/bootstrap/Spinner';
import StatusPopup from '../../../components/PlanningCalendar/StatusPopup';
import AuthContext from '../../../contexts/authContext';
import { MailMenu } from '../../../gestioneerMenu';
import { useNavigate } from 'react-router-dom';
import ClientMontantContext from '../../../contexts/clientMontantContext';
import Button from '../../../components/bootstrap/Button';

import ErrorPopup from '../../../components/extras/ErrorPopup';
import { postAPI, putAPI } from '../../../apis/backend/apiNode';
import { acceptPublicDevis } from '../../../apis/backend/apiPublic';
import SignatureInput from '../../ClientActions/Signature/SignatureInput';
import { isMobile } from 'react-device-detect';

export default function SignaturePopup({ setOpenSignature, devis, loadDevisData }) {
	const { userData } = useContext(AuthContext);
	const navigate = useNavigate();
	const sigCanvas = useRef({});
	const [sigPad, setSigPad] = useState({});
	const [disabledBtn, setDisabledBtn] = useState(true);
	const [spinner, setSpinner] = useState(false);
	const [error, setError] = useState(false);
	const [success, setSuccess] = useState(false);
	const [paiement, setPaiement] = useState(false);
	const [attachementSignature, setattachementSignature] = useState([]);
	const { clientMontant, setClientMontant } = useContext(ClientMontantContext);
	const [inputValue, setInputValue] = useState('Bon pour accord');
	const [obligation, setObligation] = useState(false);

	const base64ToFile = (base64, filename) => {
		const byteString = atob(base64);
		const arrayBuffer = new ArrayBuffer(byteString.length);
		const uint8Array = new Uint8Array(arrayBuffer);

		for (let i = 0; i < byteString.length; i++) {
			uint8Array[i] = byteString.charCodeAt(i);
		}

		return new File([arrayBuffer], filename, { type: 'image/png' });
	};

	const handleConfirm = () => {
		if (sigPad?.isEmpty()) {
			setObligation('remplir votre signature');
		} else {
			const data = sigPad?.getTrimmedCanvas().toDataURL('image/png').split(',')[1];
			confirmAvecSignature(data);
		}
	};
	const handleConfirmCanvas = () => {
		const data = sigCanvas?.current?.toDataURL('image/png').split(',')[1];
		confirmAvecSignature(data);
	};

	const confirmAvecSignature = async (data) => {
		try {
			setSpinner(true);
			const file = base64ToFile(data, 'signature.png');

			const formData = new FormData();
			formData.append('attachments', file);

			const response = await postAPI(`attachment`, formData, `/Devis/${devis._id}`);
			// const result = await acceptPublicDevis(devis._id, token, formData);
			const res = await putAPI(
				'devis',
				{ signature: response?.files?.[0]?.path },
				`/${devis._id}/accepter`,
			);

			// setPaiement(true);
			loadDevisData(res?.data);
			setOpenSignature(false);
		} catch (error) {
			console.error('Erreur lors de la confirmation avec signature :', error);
			// Optionally show an error toast or message
			// toast.error("Une erreur est survenue...");
		} finally {
			setSpinner(false);
			setError(error);
		}
	};
	const handleConfirmSansSign = async (data) => {
		try {
			setSpinner(true);

			const res = await putAPI('devis', {}, `/${devis._id}/accepter`);

			// setPaiement(true);
			loadDevisData(res?.data);
			setOpenSignature(false);
		} catch (error) {
			console.error('Erreur lors de la confirmation avec signature :', error);
			// Optionally show an error toast or message
			// toast.error("Une erreur est survenue...");
		} finally {
			setSpinner(false);
			setError(error);
		}
	};

	const handleOnClick = useCallback(
		() => navigate(`/${MailMenu?.paiement?.path}/sale.order/${devis.id}/${token}`),
		[navigate],
	);

	const CreatePaiementData = () => {
		// var amount = (30 / 100) * devis?.amount_total;
		handleOnClick();
	};
	const handleCancel = () => {
		setOpenSignature(false);
	};

	const handleClearSignature = () => {
		sigPad?.clear();
		setDisabledBtn(true);
	};
	const deleteImage = (key) => {
		const updatedImages = attachementSignature.filter((item, index) => index != key);
		setattachementSignature(updatedImages);
	};

	return (
		<>
			<Modal
				show={true}
				onHide={() => setOpenSignature(false)}
				size='md'
				scrollable
				keyboard={false}>
				<Modal.Header closeButton>
					<Modal.Title>
						<Icon icon={'Verified'} size={'2x'} className='me-2'></Icon>
						Accepter votre devis
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{!isMobile &&
						<div className='row g-4 mb-3'>
							<span className='fw-bold'>Article – Modalités de paiement</span>
							En signant ce devis le client accepte que le règlement de la prestation
							s'effectue selon les modalités suivantes :
							<ul className='m-4'>
								<li>
									30 % du montant total à la signature du devis, correspondant à
									l'acompte d'acceptation
								</li>
								<li>
									70 % du solde au comptant le jour de la pose / intervention, avant
									le départ des techniciens.
								</li>
							</ul>
							Aucun travail, livraison ou pose ne pourra être réalisé sans le paiement de
							l'acompte. Le solde est dû immédiatement à la fin de l'intervention, par
							virement instantané ou carte bancaire.
							<span className='fw-bold'>L441-10 du Code de commerce.</span>
						</div>}

					<Card hasTab shadow={'md'} className='p-2'>
						<CardTabItem id='tab' title='Dessiner'>
							<CardBody>
								<div>
									<SignatureCanvas
										penColor='black'
										canvasProps={{ className: 'signature' }}
										ref={(ref) => {
											setSigPad(ref);
										}}
										onBegin={() => {
											setDisabledBtn(false);
										}}
									/>
								</div>
							</CardBody>
							<CardFooter>
								<CardFooterRight>
									<Button
										color='primary'
										className='w-auto'
										icon='Replay'
										isLight
										onClick={handleClearSignature}>
										Effacer
									</Button>
									<Button
										color='success'
										type='submit'
										icon='FileDownloadDone'
										onClick={handleConfirm}
										disabled={spinner}>
										{spinner && <Spinner isSmall inButton />}
										{spinner ? 'En cours' : 'Accepter et signer'}
									</Button>
								</CardFooterRight>
							</CardFooter>
						</CardTabItem>

						<CardTabItem id='auto' title='Automatique'>
							<SignatureInput name={devis?.clientId?.nom} sigCanvas={sigCanvas} />
							<CardFooter>
								<CardFooterRight>
									<Button
										color='success'
										type='submit'
										icon='FileDownloadDone'
										onClick={handleConfirmCanvas}
										disabled={spinner}>
										{spinner && <Spinner isSmall inButton />}
										{spinner ? 'En cours' : 'Accepter et signer'}
									</Button>
								</CardFooterRight>
							</CardFooter>
						</CardTabItem>
					</Card>
				</Modal.Body>
				<Modal.Footer>
					<Button
						color='success'
						type='submit'
						onClick={handleConfirmSansSign}
						disabled={spinner}>
						{spinner && <Spinner isSmall inButton />}
						{spinner ? 'En cours' : 'Accepter sans signature'}
					</Button>
				</Modal.Footer>
			</Modal>

			{!!obligation && (
				<StatusPopup icon='info' color='info' title={obligation} setOpen={setObligation} />
			)}
			{!!error && <ErrorPopup error={error} setOpen={setError} />}
			{!!success && (
				<StatusPopup
					icon='Verified'
					color='success'
					title={'Super!'}
					label={success}
					setOpen={() => {
						setSuccess(false);
						// setPaymentModalStatus(false);
					}}
				/>
			)}
		</>
	);
}
